export const ApiConfig = {
    URL: process.env.API_URL || 'https://pwu1j4f3be.execute-api.us-east-2.amazonaws.com',
    PUBLIC: process.env.TOKEN || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdGF0dXMiOiJ2YWxpZCIsImlhdCI6MTcwNTAwNDgxN30.TeFZuVKHoAGihf9HLG2utLX-4s_T2Eat8xq2hBpZ8a4',
    PUBLIC_DEV: process.env.TOKEN || 'eyJhbGciOiJIUzI1NiJ9.dmFsaWQ.38_h19ALiNmSflrhS4ypbg35Wy6mI3OCdNivt2TuNNA',
    HEADERS: {
        'Content-Type': 'application/json'
    }
}
